<template>
  <!-- 公众号管理 -->
  <div class="content main-container">
    <div class="body">
      <Tabs v-model="tabNum">
        <TabPane label="绑定公众号介绍" name="1"></TabPane>
        <TabPane label="绑定公众号列表" name="2"></TabPane>
      </Tabs>
      <div v-if="tabNum == 1">
        <div class="descBox" v-for="(bean, index) in pageList" :key="index">
          <h1>{{ bean.name }}</h1>
          <div class="oprate clearfix">
            <div class="left">{{ bean.text }}</div>
            <div class="right">
              <div class="urlLink">链接：{{ bean.url }}</div>
              <Button class="copyBtn" @click="copy(bean.url)" type="primary" style="width: 80px">复制</Button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="tabNum == 2">
        <div class="toolbox clearfix" v-if="$units.pointAction('systemSet_30_1')">
          <div class="add-btn">
            <Button class="addbtn" type="warning" @click="handleAddAccount">+ 新增公众号</Button>
          </div>
        </div>
        <div class="tableBox">
          <loading :isShow="loading" />
          <Table :columns="columns" :data="dataList">
            <template slot-scope="{ row }" slot="action">
              <div class="delBtn" @click="delData(row.id)" v-if="$units.pointAction('systemSet_30_2')">删除</div>
            </template>
          </Table>
        </div>
        <div class="pageBox">
          <Page :total="allData.total" :current="pageNo" :page-size="allData.size" show-total @on-change="pageChange" style="text-align: center" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: () => ({
    base: '',
    orderUrl: '/apps/order', //我的订单
    incomeUrl: '/apps/settlement/wallet', //我的收入
    planUrl: '/apps/jump', //计划书
    noticeUrl: '/apps/notices', //重要通知
    personerUrl: '/apps/my', //个人中心
    productUrl: '/apps/product', //产品库
    tabNum: '1',
    loading: false,
    pageSize: 10,
    pageNo: 1,
    pageList: [
      { name: '首页', url: '/apps/index?', text: '包含快捷工具、最新公告、热销产品等' },
      { name: '我的订单', url: '/apps/order/index?', text: '我的订单可在线查看订单的相关状态，更好跟进后续服务' },
      { name: '我的收入', url: '/apps/settlement/overview?', text: '我的收入可在线查看已成交保单的收入' },
      { name: '计划书', url: '/apps/jump?goPage=1&', text: '计划书可在为客户推荐合适产品时进行产品选择和方案配置' },
      { name: '重要通知', url: '/apps/notices?', text: '重要通知可收到关于产品上下架及相关服务信息提醒' },
      { name: '个人中心', url: '/apps/my?', text: '个人中心可编辑相关个人信息查看钱包业绩等具体信息' },
      { name: '产品库', url: '/apps/product?', text: '产品库可查看不同保司下的产品及详情，还可根据业务员姓名获取专属产品链接' },
      { name: '展业中心', url: '/apps/product?', text: '包含我的客户、访客动态、展业工具等' },
      { name: '新版展业素材', url: '/apps/exhibitionMaterial?', text: '新版展业素材，数据来源于您内容管理中的文章管理和海报管理' },
      { name: '旧版展业素材', url: '/apps/newMaterial?', text: '旧版展业素材，数据直接来源于平台素材库' },
      { name: '新版朋友圈', url: '/friends/v2/index?', text: '新版朋友圈，数据来源于您内容管理中的朋友圈助手（h5网页用）' },
      { name: '旧版朋友圈', url: '/friends/index?', text: '旧版朋友圈，数据直接来源于平台素材库（h5网页用）' },
      { name: '续费续保', url: '/apps/exhibitionMaterial?', text: '续费续保管理' },
      { name: '预约顾问', url: '/apps/appointment?', text: '专业顾问在线服务' },
      { name: '保单托管', url: '/apps/jump?goPage=2&', text: '客户保单一键管理' },
      { name: '访客管理', url: '/apps/business/visitor?', text: '访客动态一键掌握' },
      { name: '个人名片', url: '/apps/businessCard?', text: '专业化形象展示' },
      { name: '客户管理', url: '/apps/business/customer?', text: '客户信息实时跟进' },
      { name: '在线培训', url: '/apps/course/curriculumCenter?', text: '知识充电站' },
      { name: '工单服务', url: '/apps/policys/startPolicy?', text: '服务申请及进度查询' },
    ],
    columns: [
      {
        title: '序号',
        type: 'index',
        width: 80,
        align: 'center'
      },
      {
        title: '公众号名称',
        key: 'nickName',
        minWidth: 300,
        align: 'center',
        tooltip: true
      },
      {
        title: '主体',
        key: 'principalName',
        minWidth: 200,
        align: 'center',
        tooltip: true
      },
      {
        title: '绑定时间',
        key: 'createTime',
        minWidth: 150,
        align: 'center',
        tooltip: true
      },
      {
        title: '操作',
        slot: 'action',
        align: 'center',
        width: 140,
        fixed: 'right'
      }
    ],
    dataList: [],
    allData: {}
  }),
  computed: {},
  created() {
    this.userinfo = JSON.parse(localStorage.getItem('userInfo'));
    this.pageList.forEach(item => {
      item.url = `${this.$config.h5Base}${item.url}orgId=${this.userinfo.organId}`;
    });
  },
  mounted() {
    if (!this.$units.pointAction('systemSet_30_2')) {
      this.columns.splice(this.columns.length - 1, 1);
    }
    this.getList();
    if (window.parent.location.search && window.parent.location.search.indexOf('error=1') != -1) {
      this.$notice.inquiry('授权失败，公众号未通过微信认证，无法绑定', ['确定']).then(() => {
        window.parent.location = window.parent.location.origin;
        window.location.reload();
      });
    }
  },
  methods: {
    handleAddAccount() {
      this.$notice
        .inquiry('是否确认将公众号绑定授权给蜡烛云？授权绑定后可实时接收平台公告及订单消息')
        .then(() => {
          const authUrl = `${this.$config.h5Base}/api/wechat/creatAuthLink?organId=${this.userinfo.organId}&userId=${this.userinfo.userid}`;
          console.log(authUrl);
          window.open(authUrl);
        })
        .catch(e => {});
    },
    //复制
    copy(url) {
      if (!url) {
        return;
      }
      this.$units.copyUrl(url);
    },
    getList() {
      this.loading = true;
      const data = {
        organizationId: this.userinfo.organId,
        pageSize: this.pageSize,
        pageNo: this.pageNo
      };
      this.$http({
        url: '/buz/organizationSubscription/read/list',
        type: 'POST',
        data: data,
        apiPermissionCode: 'systemSet_30_0'
      }).then(res => {
        this.loading = false;
        this.dataList = res.data;
        this.allData = res;
      });
    },
    delData(id) {
      this.$notice
        .inquiry('确认删除公众号？')
        .then(() => {
          this.$http({
            url: '/buz/organizationSubscription/del',
            type: 'GET',
            data: {
              id: id
            },
            apiPermissionCode: 'systemSet_30_2'
          }).then(res => {
            if (res.httpCode == 1) {
              this.getList();
              this.$notice.success('删除成功');
            }
          });
        })
        .catch(e => {});
    },
    pageChange(index) {
      this.pageNo = index;
      this.getList();
    }
  }
};
</script>
<style lang='scss' scoped>
@import './index';
</style>
